import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { closePopup } from 'store/actions';
import { withTranslation } from 'react-i18next';

class Popup extends PureComponent {
  _close = () => {
    const { _closePopup } = this.props;
    _closePopup();
    window.location.assign('https://www.almoukawilchaabi.ma/borne');
  };

  render() {
    const { visible, message, title, t } = this.props;
    return (
      <div
        className={visible ? 'modal fade in' : 'modal fade'}
        id="basicModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="basicModal"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="myModalLabel">
                {' '}
                {t(title)}
              </h4>
              <button
                onClick={() => this._close()}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>{t(message.toString())}</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                onClick={() => this._close()}
                className="btn btn-primary"
              >
                {t('common.close')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  visible: state.commonreducer.toJS().visible,
  message: state.commonreducer.toJS().message,
  title: state.commonreducer.toJS().title,
});

function mapDispatchToProps(dispatch) {
  return {
    _closePopup: () => dispatch(closePopup()),
  };
}

export default withTranslation('translations')(
  connect(mapStateToProps, mapDispatchToProps)(Popup)
);
